import { useEffect } from "react";
import { FairnessModal } from "../FairnessModal";
import { mainStore } from "../../mainStore";
import { InfoSection } from "../InfoSection";
import { observer } from "mobx-react-lite";
import { ErrorMsg } from "../ErrorMsg";
import { currencySymbols } from "../../constants/currencySymbols";
import { gameComponentsByGameId } from "../../constants/gameComponentsByGameId";
import { translationService } from "../../translationService";
import { OddsHistorySection } from "../OddsHistorySection";

export const DesktopApplicationWrapper = observer(() => {
  useEffect(() => {
    window.addEventListener("load", scaleApplicationWrapper);
    window.addEventListener("resize", scaleApplicationWrapper);
  }, []);

  const SelectedGameComponents = {
    BettingSection: gameComponentsByGameId[mainStore.gameId].BettingSection,
    GameSection: gameComponentsByGameId[mainStore.gameId].GameSection,
  };

  useEffect(() => {
    SelectedGameComponents.BettingSection = gameComponentsByGameId[mainStore.gameId].BettingSection;
    SelectedGameComponents.GameSection = gameComponentsByGameId[mainStore.gameId].GameSection;
    scaleApplicationWrapper();
  }, []);
  const { t, TKeys } = translationService;

  return (
    <div className="desktop-main-wrapper">
      <div className="application-wrapper">
        <div className="sidebar-wrapper">
          <div className="balance-section-wrapper">
            <div className="balance-icon-wrapper">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
                <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
                <path d="M18 12a2 2 0 0 0 0 4h4v-4z" />
              </svg>
            </div>
            <div className="balance-info">
              <span className="balance-label">{t(TKeys.BALANCE)}</span>
              <span className="balance-value">
                {currencySymbols[mainStore.currency]} {mainStore.balance}
              </span>
            </div>
          </div>
          <div className="betting-section-wrapper">
            <SelectedGameComponents.BettingSection />
          </div>
        </div>
        <div className="game-wrapper">
          <ErrorMsg />
          <OddsHistorySection />
          <SelectedGameComponents.GameSection />
        </div>
        {mainStore.fairnessSectionOpened ? <FairnessModal /> : ""}
        {mainStore.infoSectionOpened ? <InfoSection /> : ""}
      </div>
    </div>
  );
});

const scaleApplicationWrapper = () => {
  const appWrapper = document.querySelector(".application-wrapper");
  const maxWidth = 1450;
  const maxHeight = 800;
  const scaleWidth = window.innerWidth / maxWidth;
  const scaleHeight = window.innerHeight / maxHeight;
  const scale = Math.min(scaleWidth, scaleHeight);
  appWrapper.style.transform = `scale(${scale})`;
  appWrapper.style.transformOrigin = "top left";
  const offsetX = (window.innerWidth - maxWidth * scale) / 2;
  const offsetY = (window.innerHeight - maxHeight * scale) / 2;
  appWrapper.style.marginLeft = `${offsetX}px`;
  appWrapper.style.marginTop = `${offsetY}px`;
};
